import { useLanguage } from "contexts/LocalizationContext";
import { getPageUrl } from "utils/getPageUrl";
import getUrlFromLink from "utils/getUrlFromLink";
import type { ResolvedLinkProps } from "types/storyblok";
import type { URLPlaceholders } from "./useStoryblokLink.d";

const URL_PLACEHOLDERS: URLPlaceholders = {
  "{{funnel}}": "webappNewClaim",
  "{{ahp_buy_essential}}": "ahpBuyEssential",
  "{{ahp_buy_complete}}": "ahpBuyComplete",
};

export const useStoryblokLink = (storyblokLink: ResolvedLinkProps) => {
  const language = useLanguage();
  const urlPlaceholder = URL_PLACEHOLDERS[storyblokLink?.url];
  const url = (urlPlaceholder && getPageUrl(language, urlPlaceholder)) || getUrlFromLink(storyblokLink, language);
  return url;
};
